import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginBottom: theme.spacing(2),

    display: 'flex',

    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
    },
  },
  leftInput: {},
  rightInput: {
    borderWidth: '1px 1px 1px 0px',
  },
  buttons: {
    width: '20%',
    marginLeft: theme.spacing(1),

    '& button': {
      marginTop: 21,

      '& + button': {
        marginLeft: theme.spacing(1),
      },
    },

    display: 'flex',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginLeft: 0,

      '& button': {
        marginTop: 0,
      },
    },
  },
  filterIcon: {
    marginRight: 0,
    fontSize: 14,
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'end',
  },
}));
